export const ACTION_TRACKER_COLUMNS = [
  "ID",
  "Task Type",
  "Task",
  "Risk",
  "Owner",
  "Due Date",
  "Status",
  // "Source",
  // "Source URL",
  "Notes",
  // "Creation Date",
  // "Completion Date"
]

export const ACTION_TABLE_COL_WIDTHS = [
  100,120, 300, 400, 200, 150, 200, 350, 150, 200, 150, 150
]

export const HEADER_TABLE_COLS_MAP = {
  "ID": 'id',
  "Task": 'task',
  "Risk": 'risk',
  "Owner": 'owner',
  "Due Date": 'due_date',
  "Status": 'status',
  "Source": 'source_id',
  "Source URL": 'source_url',
  "Notes": 'notes',
  // files: string[],
  "Task Type":"task_type",
  "Creation Date": 'create_date',
  "Completion Date": 'completion_date'
}